import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import MainNavbar from '../Matrimony/MainNavbar';
import { setBasicDetails } from '../../Redux/userSlice';
import './Register.css';
// import Cropper from 'react-easy-crop';
// import getCroppedImg from '../../utils/cropImage';
import { useContext } from "react";
import AlertContext from "../../contexts/AlertContext";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // Access the state passed via navigate
  const { showAlert } = useContext(AlertContext);
  const { mode, userId } = location.state || {}; // Ensure 'userId' is passed along with 'mode'
  const [suggestionClicked, setSuggestionClicked] = useState(false);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [step, setStep] = useState(1);
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const handlePreviousStep = () => {
    if (step > 1) setStep(prev => prev - 1);
  };
  useEffect(() => {
    if (profile.basicDetails.dateOfBirth) {
      const [y, m, d] = profile.basicDetails.dateOfBirth.split('-');
      setDay(d);
      setMonth(m);
      setYear(y);
    }
  }, []);
  const handleNextStep = () => {
    if (step === 1) {
      const { name, age, email, phoneNumber } = profile.basicDetails;
      if (!name || !age || !email || !phoneNumber) {
        showAlert('Please fill out all required fields in Step 1.', "error");
        return;
      }
    }

    if (step === 2) {
      const { gender, qualification } = profile.basicDetails;
      if (!gender || !day || !month || !year || !qualification) {
        showAlert('Please fill out all required fields in Step 2.', "error");
        return;
      }

      // Set formatted DOB in state
      const dob = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      handleChange('dateOfBirth', dob);
    }

    setStep((prev) => prev + 1);
  };

  const days = Array.from({ length: 31 }, (_, i) => String(i + 1));
  const months = Array.from({ length: 12 }, (_, i) => String(i + 1));
  const currentYear = new Date().getFullYear();
  const maxYear = currentYear - 21; // User must be 21+
  const years = Array.from({ length: 80 }, (_, i) => String(maxYear - i)); // Last 80 years

  const suggestions = [
    "I am a kind-hearted individual who values honesty, enjoys learning, and believes in growing together with love and mutual respect.",

    "I'm a calm, understanding person who believes in emotional connection, shared dreams, and building a happy life based on trust."
  ];

  const handleSuggestionClick = (suggestion) => {
    const updatedText = profile.basicDetails.aboutMe
      ? profile.basicDetails.aboutMe + ' ' + suggestion
      : suggestion;

    handleChange('aboutMe', updatedText);
    setSuggestionClicked(true); // Hide buttons after one is clicked
  };

  const [profile, setProfile] = useState({
    basicDetails: {
      name: '',
      age: '',
      gender: '',
      dateOfBirth: '',
      qualification: '',
      profilePicture: null,
      multipleImages: [],
      shortReel: null,
      email: '',
      phoneNumber: '',
      aboutMe: '',
      userId: userId || '', // Set the userId if in edit mode
    },
  });

  // const onSelectImage = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => setImage(reader.result);
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const onCropComplete = useCallback((_, croppedAreaPixels) => {
  //   setCroppedAreaPixels(croppedAreaPixels);
  // }, []);

  // const showCroppedImage = useCallback(async () => {
  //   try {
  //     const croppedImg = await getCroppedImg(image, croppedAreaPixels);
  //     setCroppedImage(croppedImg);
  //     handleChange('profilePicture', croppedImg);
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }, [image, croppedAreaPixels]);

  const handleChange = (field, value) => {
    setProfile(prevState => ({
      ...prevState,
      basicDetails: {
        ...prevState.basicDetails,
        [field]: value,
      },
    }));
  };

  const handleFileChange = (field, files) => {
    setProfile(prevState => ({
      ...prevState,
      basicDetails: {
        ...prevState.basicDetails,
        [field]: field === 'multipleImages' ? [...files] : files[0],
      },
    }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Final validation before submission
    const {
      name,
      age,
      email,
      phoneNumber,
      gender,
      qualification,
      aboutMe,
      profilePicture,
    } = profile.basicDetails;

    // Rebuild and validate DOB
    const dob = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    if (!day || !month || !year) {
      showAlert('Please enter a valid date of birth.', "error");
      return;
    }

    // Validate all required fields
    if (!name || !age || !email || !phoneNumber || !gender || !qualification || !aboutMe) {
      return;
    }

    // Optional: basic email format check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showAlert('Please enter a valid email address.', "error");
      return;
    }

    // Save the valid DOB back to state before sending
    handleChange('dateOfBirth', dob);

    // Create FormData
    const formData = new FormData();
    Object.keys(profile.basicDetails).forEach((key) => {
      if (key === 'multipleImages') {
        profile.basicDetails[key].forEach((file) => {
          formData.append(key, file);
        });
      } else {
        formData.append(key, profile.basicDetails[key]);
      }
    });

    try {
      let response;

      if (mode === 'edit' && profile.basicDetails.userId) {
        response = await axios.put(
          `https://back.varankal.com/user/update-basic-details/${profile.basicDetails.userId}`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
          }
        );
        console.log('Updated user details:', response.data);
      } else {
        response = await axios.post(
          'https://back.varankal.com/user/register',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
          }
        );
        console.log('New user registered:', response.data);
      }

      // Store in Redux
      const basicDetails = {
        ...profile.basicDetails,
        profilePicture: '',
        multipleImages: [],
        shortReel: '',
      };

      dispatch(setBasicDetails(basicDetails));
      showAlert("Great job! You've completed your registration.");
      navigate('/create');
    } catch (error) {
      console.error('Error submitting the form', error);

      // Show backend validation message if exists
      const errorMessage =
        error?.response?.data?.message ||
        "Error submitting the form. Please try again.";

      showAlert(errorMessage);
    }

  };

  return (
    <>
      <MainNavbar />
      <div className="register-container-wrapper">
        <div className="popup-backdrop-inside">
          <div className="register-popup">
            <form onSubmit={handleSubmit} className="register-form">


              {step === 1 && (
                <div className="register-left">
                  <h2>Basic Info</h2>
                  <label>Full Name</label>
                  <input type="text" value={profile.basicDetails.name} onChange={(e) => handleChange('name', e.target.value)} />
                  <label>Age</label>
                  <select value={profile.basicDetails.age} onChange={(e) => handleChange('age', e.target.value)}>
                    <option value="">Select Age</option>
                    {Array.from({ length: 20 }, (_, i) => i + 21).map((age) => (
                      <option key={age} value={age}>{age}</option>
                    ))}
                    <option value="40+">40 and above</option>
                  </select>
                  <label>Email</label>
                  <input type="email" value={profile.basicDetails.email} onChange={(e) => handleChange('email', e.target.value)} />
                  <label>Phone Number</label>
                  <input type="text" value={profile.basicDetails.phoneNumber} onChange={(e) => handleChange('phoneNumber', e.target.value)} />
                </div>
              )}

              {step === 2 && (
                <div className="register-left">
                  <h2>Personal Info</h2>
                  <label>Gender</label>
                  <select value={profile.basicDetails.gender} onChange={(e) => handleChange('gender', e.target.value)}>
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>

                  <label>Date of Birth</label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <select value={day} onChange={(e) => setDay(e.target.value)}>
                      <option value="">DD</option>
                      {days.map(d => <option key={d} value={d}>{d}</option>)}
                    </select>
                    <select value={month} onChange={(e) => setMonth(e.target.value)}>
                      <option value="">MM</option>
                      {months.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                    <select value={year} onChange={(e) => setYear(e.target.value)}>
                      <option value="">YYYY</option>
                      {years.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>

                  <label>Qualification</label>
                  <select value={profile.basicDetails.qualification} onChange={(e) => handleChange('qualification', e.target.value)}>
                    <option value="">Select</option>
                    <option value="High School">High School</option>
                    <option value="Bachelor's Degree">Bachelor's</option>
                    <option value="Master's Degree">Master's</option>
                    <option value="Ph.D.">Ph.D.</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              )}

              {step === 3 && (
                <div className="register-right">
                  <h2>About Me</h2>
                  {!profile.basicDetails.aboutMe && (
                    <div className="suggestion-box">
                      {suggestions.map((suggestion, index) => (
                        <button
                          type="button"
                          key={index}
                          className="suggestion-button"
                          onClick={() => handleSuggestionClick(suggestion)}
                        >
                          {suggestion.slice(0, 60)}...
                        </button>
                      ))}
                    </div>
                  )}
                  <textarea
                    value={profile.basicDetails.aboutMe}
                    onChange={(e) => handleChange('aboutMe', e.target.value)}
                    placeholder="Tell us about yourself..."
                    rows={5}
                    style={{ display: profile.basicDetails.aboutMe ? 'block' : 'none', marginBottom: "20px" }}
                  />
                  {/* 
                  <h2>Upload Profile Picture</h2>
                  <input type="file" accept="image/*" onChange={onSelectImage} />
                  {image && (
                    <>
                      <div className="crop-container">
                        <Cropper
                          image={image}
                          crop={crop}
                          zoom={zoom}
                          aspect={1}
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                        />
                      </div>
                      <button type="button" onClick={showCroppedImage}>Confirm Crop</button>
                    </>
                  )} */}
                  {/* {croppedImage && (
                    <div className="cropped-image-preview">
                      <img src={croppedImage} alt="Profile Preview" className="circle-preview" />
                    </div>
                  )} */}
                  <h2>Profile Picture</h2>
                  <div className="form-section">
                    <label>Upload Profile Picture</label>
                    <input type="file" accept="image/*" onChange={(e) => handleFileChange('profilePicture', e.target.files)} />
                  </div>
                  <label>ID Proof (optional)</label>
                  <input type="file" accept="image/*" multiple onChange={(e) => handleFileChange('multipleImages', e.target.files)} />
                </div>
              )}


              <div className="navigation-group">
                {step > 1 && <button type="button" className="navigation-button" onClick={handlePreviousStep}>Back</button>}
                {step < 3
                  ? <button type="button" className="navigation-button" onClick={handleNextStep}>Next</button>
                  : <button type="submit" className="submit-buttonn">Submit</button>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </>

  );
};

export default Register;